import { change } from 'redux-form'
import { createSelector } from 'reselect'

import API from '../../../utils/http/api'

// Action Types
const REQUEST_STATES = 'steppingblocks/tuitionStates/REQUEST'
const STATES_SUCCESS = 'steppingblocks/tuitionStates/SUCCESS'
const STATES_FAILURE = 'steppingblocks/tuitionStates/FAILURE'
const REQUEST_UNIVERSITIES = 'steppingblocks/tuitionUniversities/REQUEST'
const UNIVERSITIES_SUCCESS = 'steppingblocks/tuitionUniversities/SUCCESS'
const UNIVERSITIES_FAILURE = 'steppingblocks/tuitionUniversities/FAILURE'
const REQUEST_SALARY = 'steppingblocks/tuitionSalary/REQUEST'
const SALARY_SUCCESS = 'steppingblocks/tuitionSalary/SUCCESS'
const SALARY_FAILURE = 'steppingblocks/tuitionSalary/FAILURE'
const REQUEST_UNIVERSITY_DATA = 'steppingblocks/tuitionUniversityData/REQUEST'
const UNIVERSITY_DATA_SUCCESS = 'steppingblocks/tuitionUniversityData/SUCCESS'
const UNIVERSITY_DATA_FAILURE = 'steppingblocks/tuitionUniversityData/FAILURE'

// Reducer
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  states: [],
  universities: [],
  universityData: null,
  salaryWithDegree: 0,
}

export default (reduxState = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST_STATES:
    case REQUEST_UNIVERSITIES:
    case REQUEST_UNIVERSITY_DATA:
    case REQUEST_SALARY:
      return {
        ...reduxState,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case STATES_SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        states: payload.states,
      }
    case UNIVERSITIES_SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        universities: payload.universities,
      }
    case UNIVERSITY_DATA_SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        universityData: payload.universityData,
      }
    case SALARY_SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        salaryWithDegree: payload.salary,
      }
    case STATES_FAILURE:
    case UNIVERSITIES_FAILURE:
    case UNIVERSITY_DATA_FAILURE:
    case SALARY_FAILURE:
      return {
        ...reduxState,
        requestEnded: true,
        error: payload.error,
      }
    default:
      return reduxState
  }
}

// Action Performers
export const performRetrieveStates = () => async dispatch => {
  dispatch({ type: REQUEST_STATES })
  try {
    const data = await API.get('/tuition/states')
    dispatch({
      type: STATES_SUCCESS,
      payload: {
        states: data.states,
      },
    })
  } catch (error) {
    dispatch({ type: STATES_FAILURE, payload: { error: error.message } })
  }
}

// export const performRetrieveUniversitiesForState = state => async dispatch => {
//   dispatch({ type: REQUEST_UNIVERSITIES })
//   try {
//     const data = await API.get(`/tuition/universities/${state}`)
//     dispatch({
//       type: UNIVERSITIES_SUCCESS,
//       payload: {
//         universities: data.universities,
//       },
//     })
//   } catch (error) {
//     dispatch({ type: UNIVERSITIES_FAILURE, payload: { error: error.message } })
//   }
// }

export const setStartingSalaryWithDegree = startingSalaryWithDegree => async dispatch => {
  dispatch(change('collegeAndTuitionForm', 'startingSalaryWithDegree', startingSalaryWithDegree))
}

// Selectors
const getTuition = tuition => tuition

export const states = createSelector(getTuition, tuition => tuition.states.map(state => ({ value: state, displayName: state })))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/tuitionDuck.js